/**
 *  Copyright (c) 2017 - present, The Regents of the University of California,
 *  through Lawrence Berkeley National Laboratory (subject to receipt
 *  of any required approvals from the U.S. Dept. of Energy).
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree.
 */

import React from "react";
import {TimeEvent} from "pondjs";
import {TrafficMap} from "react-network-diagrams";

import Spinner from "./spinner";

let nodes = [
    {
        id: 3,
        name: "Miami",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "bottom",
        x: 8.0,
        y: 8.0
    },
    {
        id: 4,
        name: "Fortaleza",
        type: "node",
        capacity: "100G",
//        label_dx: 14,
//        label_dy: 0,
        label_dx: null,
        label_dy: null,
        label_position: "right",
        x: 16.0,
        y: 12.0
    },
    {
        id: 5,
        name: "Sao Paulo",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "bottom",
        x: 10.0,
        y: 16.0
    },
    {
        id: 6,
        name: "Santiago de Chile",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "bottom",
        x: 4.0,
        y: 16.0
    },
    {
        id: 7,
        name: "Panama City",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "left",
        x: 4.0,
        y: 12.0
    },
    {
        id: 8,
        name: "San Juan",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "left",
        x: 4.0,
        y: 10.0
    },
    {
        id: 9,
        name: "FLR",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "top",
        x: 4.0,
        y: 4.0
    },
    {
        id: 10,
        name: "AtlanticWave",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "top",
        x: 8.0,
        y: 4.0
    },
//    {
//        id: 11,
//        name: "Internet2",
//        type: "node",
//        capacity: "100G",
//        label_dx: null,
//        label_dy: null,
//        label_position: "top",
//        x: 8.0,
//        y: 6.0
//    },
//    {
//        id: 12,
//        name: "Venezuela",
//        type: "node",
//        capacity: "1G",
//        label_dx: null,
//        label_dy: null,
//        label_position: "left",
//        x: 6.0,
//        y: 10.0
//    },
//    {
//        id: 13,
//        name: "Dominican Republic",
//        type: "node",
//        capacity: "1G",
//        label_dx: null,
//        label_dy: null,
//        label_position: "left",
//        x: 6.0,
//        y: 8.0
//    },
    {
        id: 14,
        name: "US Virgin Islands",
        type: "node",
        capacity: "10G",
        label_dx: null,
        label_dy: null,
        label_position: "right",
        x: 6.0,
        y: 11.0
    },
    {
        id: 15,
        name: "Cape Town",
        type: "node",
        capacity: "10G",
        label_dx: null,
        label_dy: null,
        label_position: "bottom",
        x: 16.0,
        y: 16.0
    },
//    {
//        id: 16,
//        name: "Luanda",
//        type: "node",
//        capacity: "100G",
//        label_dx: null,
//        label_dy: null,
//        label_position: "bottom",
//        x: 11.0,
//        y: 12.0
//    },
    {
        id: 17,
        name: "Jacksonville",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "left",
        x: 8.0,
        y: 6.0
    },
    {
        id: 18,
        name: "GEANT",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "top",
        x: 16.0,
        y: 4.0
    },
    {
        id: 19,
        name: "Buenos Aires",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "top",
        x: 8.0,
        y: 14.0
    },
    {
        id: 20,
        name: "Boca Raton",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "right",
        x: 13.0,
        y: 8.0
    },
    {
        id: 21,
        name: "Atlanta",
        type: "node",
        capacity: "400G",
        label_dx: null,
        label_dy: null,
        label_position: "right",
        x: 13.0,
        y: 6.0
   },
   {
        id: 22,
        name: "ESNET",
        type: "node",
        capacity: "100G",
        label_dx: null,
        label_dy: null,
        label_position: "top",
        x: 13.0,
        y: 4.0
    }
 	
];

let edges = [
    {
        id: 27,
        capacity: "200G",
        source: "Miami",
        target: "Jacksonville"
    },
    {
        id: 11,
        capacity: "100G",
        source: "Miami",
        target: "Fortaleza"
    },
    {
        id: 12,
        capacity: "100G",
        source: "Fortaleza",
        target: "Sao Paulo"
    },
    {
        id: 13,
        capacity: "100G",
        source: "Sao Paulo",
        target: "Santiago de Chile"
    },
    {
        id: 14,
        capacity: "100G",
        source: "Santiago de Chile",
        target: "Panama City"
    },
    {
        id: 15,
        capacity: "100G",
        source: "Panama City",
        target: "San Juan"
    },
    {
        id: 16,
        capacity: "100G",
        source: "San Juan",
        target: "Miami"
    },
    {
        id: 18,
        capacity: "100G",
        source: "Jacksonville",
        target: "AtlanticWave"
    },
    {
        id: 19,
        capacity: "100G",
        source: "Miami",
        target: "FLR"
    },
    {
        id: 24,
        capacity: "10G",
        source: "Miami",
        target: "US Virgin Islands"
    },
    {
        id: 25,
        capacity: "100G",
        source: "Fortaleza",
        target: "Cape Town"
    },
    {
        id: 33,
        capacity: "200G",
        source: "Miami",
        target: "Boca Raton"
    },
    {
        id: 30,
        capacity: "100G",
        source: "Fortaleza",
        target: "GEANT"
    },
    {
        id: 35,
        capacity: "100G",
        source: "Fortaleza",
        target: "Panama City"
    },
    {
        id: 28,
        capacity: "100G",
        source: "Sao Paulo",
        target: "Buenos Aires"
    },
    {
        id: 29,
        capacity: "100G",
        source: "Buenos Aires",
        target: "Santiago de Chile"
    },
    {
        id: 31,
        capacity: "200G",
        source: "Sao Paulo",
        target: "Boca Raton"
    },
    {
        id: 32,
        capacity: "200G",
        source: "Boca Raton",
        target: "Atlanta"
    },
    {
        id: 34,
        capacity: "100G",
        source: "Atlanta",
        target: "Jacksonville"
    },
    {
        id: 36,
        capacity: "100G",
        source: "Atlanta",
        target: "ESNET"
    },
    {
        id: 37,
        capacity: "200G",
        source: "Fortaleza",
        target: "Boca Raton"
    }
  
];

export default class Map extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mapSelection: {
                edges: [],
                nodes: []
            },
            topology: {
                name: "Cities Map",
                description: "Cities Map",
                nodes,
                edges
            }
        };
    }

    handleSelectionChanged(selectionType, selection) {

        if (selectionType === "edge" && selection === "Miami--Fortaleza") {
            this.props.trafficKeyChanged("Miami - Fortaleza");
        } else if (selectionType === "edge" && selection === "Miami--US Virgin Islands") {
            this.props.trafficKeyChanged("Miami - US Virgin Islands");
        } else if (selectionType === "edge" && selection === "Miami--Boca Raton") {
            this.props.trafficKeyChanged("Miami - Boca Raton");
        } else if (selectionType === "edge" && selection === "Miami--FLR") {
            this.props.trafficKeyChanged("Miami - FLR");
        } else if (selectionType === "edge" && selection === "Jacksonville--AtlanticWave") {
            this.props.trafficKeyChanged("Jacksonville - AtlanticWave");
        } else if (selectionType === "edge" && selection === "Atlanta--Jacksonville") {
            this.props.trafficKeyChanged("Atlanta - Jacksonville");

        } else if (selectionType === "edge" && selection === "Atlanta--ESNET") {
            this.props.trafficKeyChanged("Atlanta - ESNET");
        } else if (selectionType === "edge" && selection === "Boca Raton--Atlanta") {
            this.props.trafficKeyChanged("Boca Raton - Atlanta");
        } else if (selectionType === "edge" && selection === "Fortaleza--Boca Raton") {
            this.props.trafficKeyChanged("Fortaleza - Boca Raton");
        } else if (selectionType === "edge" && selection === "Sao Paulo--Boca Raton") {
            this.props.trafficKeyChanged("Sao Paulo - Boca Raton");
        } else if (selectionType === "edge" && selection === "Fortaleza--Sao Paulo") {
            this.props.trafficKeyChanged("Fortaleza - Sao Paulo");
        } else if (selectionType === "edge" && selection === "Sao Paulo--Santiago de Chile") {
            this.props.trafficKeyChanged("Sao Paulo - Santiago de Chile");
        } else if (selectionType === "edge" && selection === "Santiago de Chile--Panama City") {
            this.props.trafficKeyChanged("Santiago de Chile - Panama City");
        } else if (selectionType === "edge" && selection === "Panama City--San Juan") {
            this.props.trafficKeyChanged("Panama City - San Juan");
        } else if (selectionType === "edge" && selection === "San Juan--Miami") {
            this.props.trafficKeyChanged("San Juan - Miami");
        } else if (selectionType === "edge" && selection === "Fortaleza--Cape Town") {
            this.props.trafficKeyChanged("Fortaleza - Cape Town");
        } else if (selectionType === "edge" && selection === "Fortaleza--Panama City") {
            this.props.trafficKeyChanged("Fortaleza - Panama City");
        } else if (selectionType === "edge" && selection === "Miami--Jacksonville") {
            this.props.trafficKeyChanged("Miami - Jacksonville");
        } else if (selectionType === "edge" && selection === "Buenos Aires--Santiago de Chile") {
            this.props.trafficKeyChanged("Buenos Aires - Santiago de Chile");
        } else if (selectionType === "edge" && selection === "Sao Paulo--Buenos Aires") {
            this.props.trafficKeyChanged("Sao Paulo - Buenos Aires");

        } else if (this.props.trafficKey !== "Total") {
            this.props.trafficKeyChanged("Total");
        }

        let mapSelection = {
            nodes: selectionType === "node" ? [selection] : [],
            edges: selectionType === "edge" ? [selection] : []
        };

        this.setState({mapSelection});
    };

    renderDisplay = () => {
        let trafficLoaded = this.props.trafficLoaded;

        if (!trafficLoaded) {
            return <Spinner/>;
        }

        let trafficData = this.props.trafficData;

        let tracker = this.props.tracker;
        let timestamp = tracker;
        if (!tracker) {
            timestamp = trafficData["Total"].end();
        }

        let index = trafficData["Total"].bisect(timestamp);

        let edgeTraffic = {
            "Miami--Fortaleza": trafficData["Miami - Fortaleza"].at(index).get("in") / trafficData["Miami - Fortaleza"].at(index).get("capacity"),
            "Fortaleza--Miami": trafficData["Miami - Fortaleza"].at(index).get("out") / trafficData["Miami - Fortaleza"].at(index).get("capacity"),

            "Miami--US Virgin Islands": trafficData["Miami - US Virgin Islands"].at(index).get("in") / trafficData["Miami - US Virgin Islands"].at(index).get("capacity"),
            "US Virgin Islands--Miami": trafficData["Miami - US Virgin Islands"].at(index).get("out") / trafficData["Miami - US Virgin Islands"].at(index).get("capacity"),

            "Miami--FLR": trafficData["Miami - FLR"].at(index).get("in") / trafficData["Miami - FLR"].at(index).get("capacity"),
            "FLR--Miami": trafficData["Miami - FLR"].at(index).get("out") / trafficData["Miami - FLR"].at(index).get("capacity"),

            "Jacksonville--AtlanticWave": trafficData["Jacksonville - AtlanticWave"].at(index).get("in") / trafficData["Jacksonville - AtlanticWave"].at(index).get("capacity"),
            "AtlanticWave--Jacksonville": trafficData["Jacksonville - AtlanticWave"].at(index).get("out") / trafficData["Jacksonville - AtlanticWave"].at(index).get("capacity"),

            "Fortaleza--Sao Paulo": trafficData["Fortaleza - Sao Paulo"].at(index).get("in") / trafficData["Fortaleza - Sao Paulo"].at(index).get("capacity"),
            "Sao Paulo--Fortaleza": trafficData["Fortaleza - Sao Paulo"].at(index).get("out") / trafficData["Fortaleza - Sao Paulo"].at(index).get("capacity"),

            "Sao Paulo--Santiago de Chile": trafficData["Sao Paulo - Santiago de Chile"].at(index).get("in") / trafficData["Sao Paulo - Santiago de Chile"].at(index).get("capacity"),
            "Santiago de Chile--Sao Paulo": trafficData["Sao Paulo - Santiago de Chile"].at(index).get("out") / trafficData["Sao Paulo - Santiago de Chile"].at(index).get("capacity"),

            "Santiago de Chile--Panama City": trafficData["Santiago de Chile - Panama City"].at(index).get("in") / trafficData["Santiago de Chile - Panama City"].at(index).get("capacity"),
            "Panama City--Santiago de Chile": trafficData["Santiago de Chile - Panama City"].at(index).get("out") / trafficData["Santiago de Chile - Panama City"].at(index).get("capacity"),

            "Panama City--San Juan": trafficData["Panama City - San Juan"].at(index).get("in") / trafficData["Panama City - San Juan"].at(index).get("capacity"),
            "San Juan--Panama City": trafficData["Panama City - San Juan"].at(index).get("out") / trafficData["Panama City - San Juan"].at(index).get("capacity"),

            "Panama City--Fortaleza": trafficData["Fortaleza - Panama City"].at(index).get("in") / trafficData["Fortaleza - Panama City"].at(index).get("capacity"),
            "Fortaleza--Panama City": trafficData["Fortaleza - Panama City"].at(index).get("out") / trafficData["Fortaleza - Panama City"].at(index).get("capacity"),

            "San Juan--Miami": trafficData["San Juan - Miami"].at(index).get("in") / trafficData["San Juan - Miami"].at(index).get("capacity"),
            "Miami--San Juan": trafficData["San Juan - Miami"].at(index).get("out") / trafficData["San Juan - Miami"].at(index).get("capacity"),

            "Fortaleza--Cape Town": trafficData["Fortaleza - Cape Town"].at(index).get("in") / trafficData["Fortaleza - Cape Town"].at(index).get("capacity"),
            "Cape Town--Fortaleza": trafficData["Fortaleza - Cape Town"].at(index).get("out") / trafficData["Fortaleza - Cape Town"].at(index).get("capacity"),

            "Miami--Jacksonville": trafficData["Miami - Jacksonville"].at(index).get("in") / trafficData["Miami - Jacksonville"].at(index).get("capacity"),
            "Jacksonville--Miami": trafficData["Miami - Jacksonville"].at(index).get("out") / trafficData["Miami - Jacksonville"].at(index).get("capacity"),

            "Miami--Boca Raton": trafficData["Miami - Boca Raton"].at(index).get("in") / trafficData["Miami - Boca Raton"].at(index).get("capacity"),
            "Boca Raton--Miami": trafficData["Miami - Boca Raton"].at(index).get("out") / trafficData["Miami - Boca Raton"].at(index).get("capacity"),

            "Boca Raton--Atlanta": trafficData["Boca Raton - Atlanta"].at(index).get("in") / trafficData["Boca Raton - Atlanta"].at(index).get("capacity"),
            "Atlanta--Boca Raton": trafficData["Boca Raton - Atlanta"].at(index).get("out") / trafficData["Boca Raton - Atlanta"].at(index).get("capacity"),

            "Boca Raton--Fortaleza": trafficData["Fortaleza - Boca Raton"].at(index).get("in") / trafficData["Fortaleza - Boca Raton"].at(index).get("capacity"),
            "Fortaleza--Boca Raton": trafficData["Fortaleza - Boca Raton"].at(index).get("out") / trafficData["Fortaleza - Boca Raton"].at(index).get("capacity"),

            "Boca Raton--Sao Paulo": trafficData["Sao Paulo - Boca Raton"].at(index).get("in") / trafficData["Sao Paulo - Boca Raton"].at(index).get("capacity"),
            "Sao Paulo--Boca Raton": trafficData["Sao Paulo - Boca Raton"].at(index).get("out") / trafficData["Sao Paulo - Boca Raton"].at(index).get("capacity"),

            "Jacksonville--Atlanta": trafficData["Atlanta - Jacksonville"].at(index).get("in") / trafficData["Atlanta - Jacksonville"].at(index).get("capacity"),
            "Atlanta--Jacksonville": trafficData["Atlanta - Jacksonville"].at(index).get("out") / trafficData["Atlanta - Jacksonville"].at(index).get("capacity")


        };

        let traffic = new TimeEvent(timestamp, edgeTraffic);

        const bounds = {
            x1: 2,
            y1: 2,
            x2: 18,
            y2: 18
        };

        // Maps link capacity to line thickness
        const edgeThinknessMap = {
            "200G": 7, 
            "100G": 5,
            "10G": 3,
            "1G": 1.5
        };

        const edgeColorMap = [
            { color: "#990000", label: ">=80%", range: [0.80, 1.0] },
            { color: "#e31a1c", label: "60 - 79", range: [0.60, 0.79] },
            { color: "#f16913", label: "45 - 59", range: [0.45, 0.59] },
            { color: "#ffd300", label: "10 - 44", range: [0.10, 0.44] },
     //       { color: "#016c59", label: "15 - 20", range: [0.15, 0.20] },
       //     { color: "#238b45", label: "10 - 15", range: [0.10, 0.15] },
            { color: "#225ea8", label: "5 - 9", range: [0.05, 0.9] },
            { color: "#74a9cf", label: "0 - 4", range: [0, 0.04] }
            // { color: "#74a9cf", label: "0.01 - 5", range: [0.001, 0.05] },
            // { color: "#000000", label: "0 - 0.01", range: [0.0, 0.001] }
        ];

        const nodeShapeMap = {
            Internet2: "cloud",
            AtlanticWave: "cloud",
            FLR: "cloud",
            GEANT: "cloud",
            ESNET: "cloud"
        };


        const hubStyle = {
            node: {
                normal: {
                    fill: "#CBCBCB", stroke: "#BEBEBE", cursor: "pointer"
                },
                selected: {
                    fill: "#37B6D3", stroke: "rgba(55, 182, 211, 0.22)", strokeWidth: 10, cursor: "pointer"
                },
                muted: {
                    fill: "#CBCBCB", stroke: "#BEBEBE", opacity: 0.6, cursor: "pointer"
                }
            },
            label: {
                normal: {
                    fill: "#696969", stroke: "none", fontSize: 9
                },
                selected: {
                    fill: "#333", stroke: "none", fontSize: 11
                },
                muted: {
                    fill: "#696969", stroke: "none", fontSize: 8, opacity: 0.6
                }
            }
        };

        // Mapping of node type to style
        const stylesMap = {
            hub: hubStyle
        };

        const nodeSizeMap = {
            hub: 10
        };

        // Maps edge name to edge shape. Current options are linear (default)
        // or curved. If curved you can specify the direction and offset
        // to control the curve.
        const edgeShapeMap = {
            "Miami--FLR": {
                shape: "curved",
                direction: "left",
                offset: 15
            },
//            "Jacksonville--AtlanticWave": {
//                shape: "curved",
//                direction: "right",
//                offset: 15
//            },
            "Miami--Fortaleza": {
                shape: "curved",
                direction: "left",
                offset: 15
            },
//            "Miami--Sao Paulo": {
//                shape: "curved",
//                direction: "left",
//                offset: 15
//            },
//            "San Juan--Miami": {
//                shape: "curved",
//                direction: "right",
//                offset: 15
//            },
//            "MCT01--SouthernLight2": {
//                shape: "curved",
//                direction: "left",
//                offset: 15
//            },
//            "Miami--Venezuela": {
//                shape: "curved",
//                direction: "right",
//                offset: 15
//            },
//            "Miami--Dominican Republic": {
//                shape: "curved",
//                direction: "left",
//                offset: 15
//            },
            "Miami--US Virgin Islands": {
                shape: "curved",
                direction: "left",
                offset: 15
            }
        };

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <TrafficMap
                            autoSize={false}
                            bounds={bounds}
                            topology={this.state.topology}
                            traffic={traffic}
                            edgeColorMap={edgeColorMap}
                            edgeDrawingMethod="bidirectionalArrow"
                            edgeThinknessMap={edgeThinknessMap}
                            edgeShapeMap={edgeShapeMap}
                            nodeSizeMap={nodeSizeMap}
                            nodeShapeMap={nodeShapeMap}
                            stylesMap={stylesMap}
                            selection={this.state.mapSelection}
                            onSelectionChange={(selectionType, selection) => this.handleSelectionChanged(selectionType, selection)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return this.renderDisplay();
    }
};



// WEBPACK FOOTER //
// src/components/map.js